import {publicApi} from 'services/api';

import {LoadResponse} from 'pages/Loads/types';

export const getLoadInfo = (ttn: number): Promise<LoadResponse> => {
    const url = `/track/${ttn}`;
    return publicApi.get(url).then((response) => response?.data);
};
